const footer = {
  footer: {
    privacy: '개인정보 처리방침',
    terms: '이용약관',
    refund: '환불 정책',
  }
};

export default footer;
